// extracted by mini-css-extract-plugin
module.exports = {"showallourbesttoo":"institutionCardList_showallourbesttoo__3a8J-"};